<template>
  <div class="viewer-layout">
    <main class="viewer-main">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
// Minimal layout for viewer page - no sidebar, no nav bar, no title
</script>

<style scoped>
.viewer-layout {
  display: flex;
  min-height: 100vh;
  background: var(--color-bg-gradient-secondary);
}

.viewer-main {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>

